<script setup>
const props = defineProps({
  actions: {
    type: Array,
    required: true,
  },
})
</script>

<template>
  <q-btn flat round icon="mdi-dots-vertical">
    <q-menu anchor="bottom right" self="top right">
      <q-list style="min-width: 12.5rem">
        <q-item
          v-for="action in props.actions"
          :key="action.key"
          v-close-popup
          clickable
          @click="action.handler()"
        >
          <q-item-section avatar><q-icon :name="action.icon" /></q-item-section>
          <q-item-section>{{ action.label }}</q-item-section>
        </q-item>
      </q-list>
    </q-menu>
  </q-btn>
</template>
